/* The existing theme remains responsible for variant, image, price and quote updates. */
(() => {
  const init = () => document.querySelectorAll('[data-unitron-choice]').forEach(choice => {
    if (choice.dataset.ready) return;
    if (!window.jQuery) return;
    const form = choice.closest('form');
    const root = choice.closest('.product-page');
    const nativeChoice = form?.querySelector('.selector-wrapper[data-n-opt="Technikstufe"]');
    const selectors = [...(form?.querySelectorAll('select.sgl-opt-selector') || [])];
    const optionIndex = Number(choice.dataset.unitronOptionIndex);
    const source = document.getElementById('ProductJson-' + choice.dataset.unitronSection);
    if (!root || !nativeChoice || !selectors[optionIndex] || !source) return;
    let product;
    try { product = JSON.parse(source.textContent); } catch { return; }
    if (!Array.isArray(product.variants)) return;
    choice.dataset.ready = 'true';
    const money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    const cards = [...choice.querySelectorAll('[data-unitron-level]')];
    let familyConfig = {};
    try { familyConfig = JSON.parse(root.querySelector('[data-unitron-family-config]')?.textContent || '{}'); } catch {}
    const prices = [...root.querySelectorAll('[data-unitron-price]')];
    const picks = [...root.querySelectorAll('[data-unitron-pick]')];
    const requests = [...root.querySelectorAll('[data-unitron-request-level]')];
    let scheduled = false;
    let galleryVariantId = null;
    const values = () => selectors.map(s => s.value);
    const variantFor = (level, options) => product.variants.find(v =>
      v.options.every((value, index) => String(value) === String(index === optionIndex ? level : options[index]))
    );
    const imagePath = src => {
      try { return new URL(src, location.href).pathname; } catch { return ''; }
    };
    const syncGallery = variant => {
      if (!variant || variant.id === galleryVariantId) return;
      const gallery = root.querySelector('.product-images .photos-wrapper');
      const expected = imagePath(variant.featured_media?.preview_image?.src || variant.featured_image?.src);
      if (!expected || !gallery?.swiper?.slideTo || gallery.swiper.destroyed) return;
      const slides = [...gallery.querySelectorAll('.p-sgl__photos-item')];
      // Shopify's local preview rewrites CDN hosts to relative paths.
      const index = slides.findIndex(slide => imagePath(slide.dataset.src) === expected);
      if (index < 0) return;
      try { gallery.swiper.slideTo(index, 0, false); }
      catch { return; }
      galleryVariantId = variant.id;
    };
    const sync = () => {
      scheduled = false;
      const options = values();
      const level = options[optionIndex];
      const activeVariant = variantFor(level, options);
      const build = options[1];
      if (familyConfig[build]) {
        root.querySelectorAll('[data-unitron-for-build]').forEach(node => {
          node.hidden = node.dataset.unitronForBuild !== build;
        });
        root.querySelectorAll('[data-unitron-build-note]').forEach(node => {
          node.textContent = familyConfig[build].note;
        });
        if (!activeVariant) {
          const fallback = product.variants.find(v => v.available && v.options.slice(1).every((value, i) => value === options[i + 1]));
          if (fallback && choose(String(fallback.options[optionIndex]))) return;
        }
      }
      const pricePending = activeVariant && activeVariant.price === 0;
      root.classList.toggle('unitron-price-pending', !!pricePending);
      root.querySelectorAll('[data-unitron-pending-message]').forEach(node => node.hidden = !pricePending);
      syncGallery(variantFor(level, options));
      cards.forEach(card => {
        const variant = variantFor(card.dataset.unitronLevel, options);
        const active = card.dataset.unitronLevel === level;
        card.classList.toggle('is-selected', active);
        card.setAttribute('aria-pressed', String(active));
        card.disabled = !variant || !variant.available;
        const state = card.querySelector('[data-unitron-state]');
        const text = !variant || !variant.available ? 'Nicht verfügbar' : active ? 'Ausgewählt' : 'Auswählen';
        if (state.textContent !== text) state.textContent = text;
      });
      prices.forEach(price => {
        const variant = variantFor(price.dataset.unitronPrice, options);
        const text = variant ? (variant.price === 0 ? 'Preis auf Anfrage' : money.format(variant.price / 100)) : 'Nicht verfügbar';
        if (price.textContent.trim() !== text) price.textContent = text;
      });
      picks.forEach(pick => {
        const variant = variantFor(pick.dataset.unitronPick, options);
        pick.setAttribute('aria-disabled', String(!variant || !variant.available));
        if (variant) pick.href = `${product.url || location.pathname}?variant=${variant.id}#pm-product-choice`;
      });
      requests.forEach(button => {
        const variant = variantFor(button.dataset.unitronRequestLevel, options);
        button.disabled = !variant || !variant.available;
      });
      choice.querySelectorAll('[data-unitron-explanation]').forEach(node => {
        node.hidden = node.dataset.unitronExplanation !== level;
      });
      root.querySelectorAll('[data-unitron-story] [data-unitron-column]').forEach(cell => {
        cell.classList.toggle('is-selected', cell.dataset.unitronColumn === level);
      });
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(sync);
    };
    const choose = level => {
      const match = variantFor(level, values());
      if (!match || !match.available) return false;
      const original = [...nativeChoice.querySelectorAll('.--js-opt[data-value]')].find(item => item.dataset.value === level);
      if (!original || !window.jQuery) return false;
      // Use the theme's normal swatch path, preserving all other option selections.
      window.jQuery(original).trigger('click');
      schedule();
      return true;
    };
    choice.addEventListener('click', event => {
      const card = event.target.closest('[data-unitron-level]');
      if (card && !card.disabled) choose(card.dataset.unitronLevel);
    });
    root.addEventListener('click', event => {
      if (event.target.closest('[data-unitron-family-compare]')) {
        const active = [...root.querySelectorAll('[data-unitron-for-build]')].find(node => !node.hidden && node.querySelector('[data-unitron-story]'));
        const table = active?.querySelector('[id$="-vergleich"]');
        if (table) { event.preventDefault(); table.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        return;
      }
      if (!event.target.closest('[data-unitron-story]')) return;
      const pick = event.target.closest('[data-unitron-pick]');
      if (!pick) return;
      if (pick.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      if (choose(pick.dataset.unitronPick)) {
        event.preventDefault();
        choice.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        choice.querySelector(`[data-unitron-level="${pick.dataset.unitronPick}"]`)?.focus({ preventScroll: true });
      }
    });
    root.querySelectorAll('[data-unitron-request]').forEach(link => link.addEventListener('click', event => {
      const trigger = form.querySelector('[id^="kv-anfrage-trigger-"]');
      if (!trigger) return;
      event.preventDefault();
      if (link.dataset.unitronRequestLevel && !choose(link.dataset.unitronRequestLevel)) return;
      sync();
      trigger.click();
    }));
    form.addEventListener('change', schedule);
    if (window.jQuery) window.jQuery(form).on('variantChange.unitronAddition', schedule);
    // Legacy swatches also update selected classes and labels without native change events.
    const observer = new MutationObserver(schedule);
    form.querySelectorAll('.selector-wrapper').forEach(wrapper => observer.observe(wrapper, {
      subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class']
    }));
    window.addEventListener('pageshow', schedule);
    window.addEventListener('load', schedule, { once: true });
    // Show the enhanced chooser only after the original variant controls have initialized.
    if (window.jQuery) {
      nativeChoice.before(choice);
      nativeChoice.hidden = true;
      choice.hidden = false;
    }
    sync();
  });
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init, { once: true });
  document.addEventListener('shopify:section:load', init);
})();
